import React from 'react';
import { useTheme } from '@emotion/react';
import { GumtreeTheme } from '@gumtree/ui-library/src/base/themes/gumtree-theme';
import { qaAttribute } from '@gumtree/ui-library/src/utils/qa-service';

import {
    getIconWrapperCss,
    getSegmentedButtonCss,
    getSegmentedButtonsContainerCss,
} from './segmented-buttons.style';
import Icon from '../icons/icon';

export interface SegmentedButtonOption {
    label: string;
    value: string | number;
}

const SegmentedButtons = ({
    options,
    selectedOption,
    updateSelectedOption,
    dataQ,
}: {
    options: Array<SegmentedButtonOption>;
    selectedOption?: string | number | undefined;
    updateSelectedOption: (option: string | number) => void;
    dataQ?: string;
}) => {
    const theme = useTheme() as GumtreeTheme;

    return (
        <div css={getSegmentedButtonsContainerCss(theme)} {...(dataQ && qaAttribute(dataQ))}>
            {options.map((option) => {
                const isSelected = selectedOption === option.value;

                return (
                    <button
                        key={option.value}
                        type="button"
                        css={getSegmentedButtonCss(theme, isSelected)}
                        onClick={() => {
                            updateSelectedOption(option.value);
                        }}
                    >
                        {isSelected && (
                            <div css={getIconWrapperCss(theme)}>
                                <Icon type="checkmark" color={theme.palette.secondary.main} />
                            </div>
                        )}
                        <span>{option.label}</span>
                    </button>
                );
            })}
        </div>
    );
};

export default SegmentedButtons;
